import { emptySelectOptionZod } from 'components/Select'
import { UserSlice } from 'features/user/forms/UserPublisherForm/types'
import { WorkspaceSlice } from '../../hooks/useGetWorkspaceOptions'
import { CommonSchema } from './common'

export const addSchemaDefault = (user: UserSlice): CommonSchema => ({
  role: 'viewer',
  userId: user.id,
  workspaceId: emptySelectOptionZod<WorkspaceSlice>(),
})
